export default __webpack_public_path__ + "static/media/Room_Map.2fcc2943.png";